import { FAQType } from '../types/subscription';

export const SUPPLIER_TOP_FAQ: FAQType[] = [
  {
    question: 'What is Pietra?',
    answer:
      'Pietra is a platform that allows manufacturers to connect with Creators who are interested in creating products. We are based in NYC and have a Global Partner Network that services Creators from around the world.',
  },
  {
    question: "Who are Pietra's Creators?",
    answer:
      "Pietra's Creators are influencers and independent makers who want to launch their own product lines. They may also be entrepreneurs with existing businesses which need new manufacturers to help expand their product offerings.",
  },
  {
    question: 'How much does it cost?',
    answer: 'As of May 1st 2023, a 5% commission will be deducted from all transactions.',
  },
  {
    question: 'Can I set my own MOQs & pricing?',
    answer: 'All Partners set their own MOQs and pricing for creators.',
  },
  {
    question: 'How do I charge Creators?',
    answer:
      'You should use the chat to collect all the details for the project or sample you are about to create. Once a price has been agreed upon, use the Create Invoice button at the top of the chat to charge the creator. You may add as many line items to this invoice as needed.',
  },
  {
    question: 'Which Creator brands have been launched on Pietra?',
    answer:
      'To view some of the Creator brands that Pietra has launched, please visit our homepage, marketplace, and Instagram.',
  },
];
